/* eslint-disable */

import { COLOR_MAP } from './AssetDonutChart';

const AssetAllocationTable = ({ assets, hideTitle = false, hideCard = false }) => {
    // Format currency in Indian number system
    const formatIndianCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0,
        }).format(amount);
    };

    // Format percentage to 2 decimal places
    const formatPercentage = (percentage) => {
        return parseFloat(percentage).toFixed(2);
    };

    // Calculate total
    const totalAmount = assets?.reduce((sum, asset) => sum + asset.amount, 0);
    const totalPercentage = assets?.reduce((sum, asset) => sum + asset.percentage, 0);

    const content = (
        <>
            {!hideTitle && (
                <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200">
                    <h2 className="text-base sm:text-lg">Asset Allocation</h2>
                </div>
            )}

            <div className="overflow-x-auto">
                <div className="rounded-lg border border-gray-200 overflow-hidden">
                    <table className="w-full">
                        <thead>
                            <tr className="bg-gray-50 border-b border-gray-200">
                                <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm text-gray-600">
                                    Asset Category
                                </th>
                                <th className="px-4 sm:px-6 py-3 text-right text-xs sm:text-sm text-gray-600">
                                    Amount
                                </th>
                                <th className="px-4 sm:px-6 py-3 text-right text-xs sm:text-sm text-gray-600 whitespace-nowrap">
                                    Share (%)
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {assets?.map((asset, index) => (
                                <tr
                                    key={asset.category}
                                    className={`border-b border-gray-100 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
                                        }`}
                                >
                                    <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900">
                                        <div className="flex items-center gap-2">
                                            <div
                                                className="w-3 h-3 rounded-full flex-shrink-0"
                                                style={{ backgroundColor: COLOR_MAP[asset.category] || '#6B7280' }}
                                            />
                                            <span>{asset.category}</span>
                                        </div>
                                    </td>
                                    <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums">
                                        {formatIndianCurrency(asset.amount)}
                                    </td>
                                    <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums">
                                        {formatPercentage(asset.percentage)}%
                                    </td>
                                </tr>
                            ))}

                            {/* Total Row */}
                            <tr className="bg-teal-50 border-t-2 border-teal-200">
                                <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900">
                                    Total
                                </td>
                                <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums">
                                    {formatIndianCurrency(totalAmount)}
                                </td>
                                <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-teal-700 text-right tabular-nums">
                                    {formatPercentage(totalPercentage)}%
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );

    if (hideCard) {
        return content;
    }

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            {content}
        </div>
    );
}

export default AssetAllocationTable;